module.exports = __webpack_public_path__ + "img/xqgl3.1fd88868.png";